import React, { useEffect, useState } from "react";
import ProjectDetail from "./ProjectDetail";
import { useSearchParams } from "react-router-dom";
import SaveAlertDialog from "../../SaveAlertDialog";

export default function PreviewPage() {
  const [data, setData] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const savePopup = searchParams.get("savePopup") || false;
  const pName = searchParams.get("project") || "";

  useEffect(() => {
    const response = localStorage.getItem("projectData") || null;
    if (response) {
      setData(JSON.parse(response));
    }
  }, []);

  if (!data) {
    return <div>No data</div>;
  }

  return (
    <div>
      <ProjectDetail projectData={data} isPreview={true} pName={pName} />
      <SaveAlertDialog
        open={savePopup === "true"}
        onClose={() => {
          setSearchParams((prev) => {
            prev.delete("savePopup");
            return prev;
          });
        }}
      />
    </div>
  );
}
